import { DataResult } from "@progress/kendo-data-query";

export const emptyDataGridResult: DataResult = {
  data: [],
  total: 0,
};
